var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMinimize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,0H1L0,1V23l1,1H23l1-1V1l-1-1Zm-1,22H2V2H22V22ZM7.59,9L3.29,4.71l1.41-1.41,4.29,4.29v-3.59h2v7H4v-2h3.59Zm7.41,11h-2v-7h7v2h-3.59l4.29,4.29-1.41,1.41-4.29-4.29v3.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinimize);
export default __webpack_public_path__ + "static/1787897133/media/icon-minimize.21e1c99e5ed8a25c0638f501f900ef35.svg";
export { ForwardRef as ReactComponent };